/**
 * Removes horizontal rules and table/cell borders from email HTML so sections
 * don't get straight divider lines. Elements marked data-dp-keep (used by the
 * visual email builder's Table and Divider blocks) are left alone.
 *
 * Keep in sync with backend/utils/stripEmailBorders.js
 */
const BORDER_DECL = /^\s*border(?:-(?:top|bottom|left|right))?\s*:/i;

function stripStyle(attrs) {
    return attrs.replace(/\sstyle\s*=\s*("([^"]*)"|'([^']*)')/i, (m, q, dq, sq) => {
        const kept = (dq !== undefined ? dq : sq)
            .split(';')
            .filter((decl) => decl.trim() && !BORDER_DECL.test(decl));
        return kept.length ? ` style="${kept.join(';').trim()};"` : '';
    });
}

function stripEmailBorders(html) {
    if (typeof html !== 'string' || !html) return html;
    return html
        .replace(/<hr\b[^>]*>/gi, (m) => (/data-dp-keep/i.test(m) ? m : ''))
        .replace(/<(table|tr|td|th)\b([^>]*)>/gi, (m, tag, attrs) => {
            if (/data-dp-keep/i.test(attrs)) return m;
            const cleaned = stripStyle(attrs).replace(/\sborder\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, '');
            return `<${tag}${cleaned}>`;
        })
        .replace(/\sdata-dp-keep(?:="[^"]*")?/gi, '');
}

export { stripEmailBorders };
